<template>
  <div>
    <div class="row page-heading">
      <div class="col-md-12">
        <div class="actions pull-right">
          <span class="m-r">
            <input-checkbox-boolean v-model="misReservas" tipo="switch">
              {{ $I18n.t('mis_reservas') }}
            </input-checkbox-boolean>
          </span>
          <a class="btn btn-cifra" @click="showModalFiltros = true">
            <i class="far fa-search"></i> {{ $I18n.t('Filtrar') }}
          </a>
          <a v-if="puedeVerListado" class="btn btn-default" href="/recursos/reservas">
            <i class="far fa-list"></i> {{ $I18n.t('Listado') }}
          </a>
          <a v-if="volverUrl" class="btn btn-default" :href="volverUrl">
            <i class="fa fa-angle-left"></i> {{ $I18n.t('Volver') }}
          </a>
        </div>
        <h2>
          {{ $I18n.t('calendario_reservas') }}
        </h2>
        <transition
          enter-active-class="animated fadeInDown"
          leave-active-class="animated fadeOutUp"
        >
          <div v-if="labelsFiltros.length">
            <span class="m-r-xs">{{ $I18n.t('filtros_aplicados') }}:</span>
            <div
              v-for="label in labelsFiltros"
              :key="label.id"
              class="label label-default m-r-xs clickable"
              @click.prevent="eliminarFiltro(label)"
            >
              {{ label.nombre }}
              <i class="m-l-xs fa fa-times font-12x"></i>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <ModalSimple
      v-model="showModalFiltros"
      tamano="lg"
      :altura-completa="true"
    >
      <selector-recursos
        :ids-recursos="idsRecursosFiltro"
        @cancelado="showModalFiltros = false"
        @aceptado="filtrosAceptados($event)"
      />
    </ModalSimple>
    <calendario
      ref="calendario"
      class="m-t"
      :puede-anadir="true"
      :event-source="eventSource"
      @dates-selected="fechasSeleccionadas"
      @event-new="eventNew"
      @event-click="eventShow"
      @event-moved="eventMoved"
      @event-render="eventRender"
    />
    <ModalSimple
      id="modal-reserva"
      v-model="showModalReserva"
    >
      <form-reserva
        v-if="showModalReserva"
        ref="formReserva"
        :reserva-id="reservaId"
        :recurso-id="recursoIdFormulario"
        :usuario-id="usuarioIdFormulario"
        :disabled="formReservaDisabled"
        :puede-cambiar-usuario="puedeReservarOtrosUsuarios"
        @guardado="cerrarModal"
        @eliminado="cerrarModal"
        @cancelado="cerrarModal"
      />
    </ModalSimple>
  </div>
</template>

<script>
import { nextTick } from 'vue';
import { addHours, differenceInMinutes } from 'date-fns';
import recursos from '@/api/recursos';
import usuarios from '@/api/usuarios';
import ModalSimple from '@/components/ModalSimple.vue';
import { showApiErrors } from '../../../libs/cifra/flash';
import toast from '../../../libs/cifra/toast';
import SelectorRecursos from './SelectorRecursos.vue';

export default {
  components: { SelectorRecursos, ModalSimple },
  props: {
    recursoId: { type: Number, default: null },
    puedeVerListado: { type: Boolean, default: false },
    puedeReservarOtrosUsuarios: { type: Boolean, default: false },
    usuario: { type: Object, required: true },
    precargarUsuario: { type: Boolean, default: false },
    volverUrl: { type: String, default: null },
  },
  data() {
    return {
      infoFechas: null,
      recursosFiltro: [],
      reservaId: null,
      cargado: false,
      formReservaDisabled: true,
      misReservas: false,
      showModalFiltros: false,
      showModalReserva: false,
    };
  },
  computed: {
    eventSource() {
      if (!this.cargado) {
        return '';
      }

      let url = '/api_publica/v1/recursos/reservas?1=1';
      if (this.recursosFiltro.length) {
        const params = this.recursosFiltro.map((recurso) => `recurso_id[]=${recurso.id}`).join('&');
        url = `${url}&${params}`;
      }
      if (this.misReservas && this.usuario) {
        url = `${url}&usuario_id=${this.usuario.id}`;
      }
      return url;
    },
    recursoIdFormulario() {
      if (this.recursosFiltro.length === 1) {
        return parseInt(this.recursosFiltro[0].id, 10);
      }
      return undefined;
    },
    // Si no puede reservar para otros usuarios, indicamos el id del usuario actual.
    // Obviamente desde fuera del componente nos han tenido que pasar los datos del usuario
    usuarioIdFormulario() {
      return !this.puedeReservarOtrosUsuarios || this.precargarUsuario ? this.usuario.id : null;
    },
    idsRecursosFiltro() {
      return this.recursosFiltro.map((re) => re.id);
    },
    labelsFiltros() {
      const labels = [...this.recursosFiltro];
      if (this.misReservas) {
        labels.push({
          id: 'misreservas',
          nombre: this.$I18n.t('mis_reservas'),
        });
      }
      return labels;
    },
  },
  watch: {
    showModalReserva() {
      if (this.showModalReserva) {
        nextTick(() => {
          this.prepararModal();
        });
      }
    },
  },
  mounted() {
    if (this.recursoId) {
      recursos.recursos.get(this.recursoId).then((result) => {
        this.recursosFiltro = [result.data];
        this.cargado = true;
      });
    } else {
      this.cargado = true;
    }
  },
  methods: {
    eventRender(arg) {
      // Fullcalendar deja los campos estandar en event y los que no son de
      // fullcalendar los mete en event.extendedProps
      const { event, el, view } = arg;
      const extra = event.extendedProps;

      const title = el.querySelector('.fc-event-title, .fc-list-event-title');
      // Si es menos de 55 minutos no cabe en la vista semanal.
      if (view.type !== 'timeGridWeek' || differenceInMinutes(event.end, event.start) >= 55) {
        title.insertAdjacentHTML('beforeend', `<small>${usuarios.fullname(extra.usuario)}</small>`);
      }
    },
    eventNew(info) {
      this.infoFechas = info;
      this.reservaId = null;
      this.formReservaDisabled = false;
      this.showModalReserva = true;
    },
    eventShow(info) {
      this.reservaId = parseInt(info.event.id, 10);
      this.formReservaDisabled = !info.event.startEditable;
      this.showModalReserva = true;
    },
    eventMoved(info) {
      const { event } = info;

      let fechaFin = event.end;

      if (!fechaFin) {
        // FullCalendar always set end to null when allDay changes as you can see in the doc
        // Así que si es null le ponemos el mismo día pero una hora más
        fechaFin = addHours(event.start, 1);
      }
      recursos.reservas.mover({
        reserva: {
          id: event.id,
          fecha_inicio: event.start,
          fecha_fin: fechaFin,
          todo_el_dia: event.allDay,
        },
      }).then((_result) => {
        this.getCalendar().refetchEvents();
        toast.success(this.$I18n.t('reserva_correcta'));
      }).catch((result) => {
        showApiErrors(result);
        this.getCalendar().refetchEvents();
      });
    },
    fechasSeleccionadas(info) {
      this.eventNew(info);
      this.getCalendar().unselect();
    },
    filtrosAceptados(recurs) {
      this.recursosFiltro = recurs;
      this.showModalFiltros = false;
    },
    eliminarFiltro(recurso) {
      if (recurso.id !== 'misreservas') {
        this.recursosFiltro = this.recursosFiltro.filter((re) => re.id !== recurso.id);
      } else {
        this.misReservas = false;
      }
    },
    prepararModal() {
      if (this.infoFechas) {
        this.$refs.formReserva.fechasSeleccionadas(this.infoFechas);
        this.infoFechas = null;
      }
    },
    cerrarModal() {
      this.showModalReserva = false;
      this.getCalendar().refetchEvents();
    },
    getCalendar() {
      return this.$refs.calendario.getCalendar();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../assets/stylesheets/cifra/vars/main.scss";

  .actions {
    .btn {
      margin-left: $margin-xs;
    }
  }

  .label.clickable:hover {
    color: $cifra-color;
  }
  .calendario :deep() {
    .fc-event-title {
      font-weight: bold;
      small {
        display: block;
        font-weight: normal;
      }
    }
    .fc-list-event-title small {
      margin-left: 10px;
    }
  }
  #modal-reserva {
    :deep(.titulo-seccion) {
      margin-top: 0;
    }
    /* Para que se vean los selectores de fecha y hora */
    :deep(.vm--modal) {
      overflow: visible;
    }
  }
</style>
